import executeQuery from "#lib/db"

export const getIngredientTypes = async () => {
	const list = await executeQuery({
		query: "select * from ingredient_types",
	})

	return list
}
